/** @module store/chai_scripts */
import { getChaiScript, getChaiScripts } from '@/api/ems_chai_scripts'

const state = () => ({
  id: null,
  data: null
})

const mutations = {
  SET_ID: (state, { id }) => {
    state.id = id
  },
  SET_DATA: (state, { data }) => {
    state.data = data
  },
  SET_VALUE: (state, { index = null, type, value }) => {
    if (state.data[index]) {
      if (Object.keys(state.data[index].attrs).includes(type)) {
        state.data[index].attrs[type] = value
      }
    } else if (Object.keys(state.data.attrs).includes(type)) {
      state.data[index].attrs[type] = value
    }
  }
}

const getters = {
  data: (state) => {
    return state.data
  },
  dataLength: (state) => {
    if (!Array.isArray(state.data)) return -1

    return state.data.length
  },
  getScript: (state) => {
    return (index) => {
      if (state.data[index]) {
        return state.data[index]
      } else {
        return state.data
      }
    }
  },
  priorities: (state) => {
    if (!state.data) return []

    if (!Array.isArray(state.data)) return [state.data.attrs?.priority]

    const prios = []
    for (const s of state.data) {
      if (s.attrs?.priority) {
        prios.push(s.attrs.priority)
      }
    }
    return prios
  },
  scriptId: (state) => {
    return state.id
  }
}

const actions = {
  getScript({ commit }, { ctxt, emsId, scriptId = null }) {
    if (!scriptId) return

    return getChaiScripts({ ctxt, emsId }).then((rsp) => {
      let exists = false
      if (Array.isArray(rsp.payload.data)) {
        for (const script of rsp.payload.data) {
          if (script.id === scriptId) {
            exists = true
          }
        }
        if (exists) {
          return getChaiScript({ ctxt, emsId, scriptId }).then((rsp) => {
            commit('SET_ID', { id: scriptId })
            setAddGridToDefault(rsp.payload.data.attributes.prmts)
            commit('SET_DATA', { data: rsp.payload.data.attributes.prmts })
          })
        } else {
          return false
        }
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

const setAddGridToDefault = (scripts) => {
  for (const script of scripts) {
    if ('addGrid' in script.attrs) {
      script.attrs.addGrid = script.attrs.addGrid ?? 0
    }
  }
}
